import jsPDF from "jspdf";

/**
 * Generates the onboarding PDF.
 * @param {Object} params - All required data for the PDF.
 * @param {string} params.logoBase64
 * @param {Object} params.organizationInfo
 * @param {Array} params.buildings
 * @param {boolean} params.agreeConditions
 * @param {boolean} params.agreeMandate
 */
export function generatePDF({
    logoBase64,
    organizationPayload,
    buildingsPayload,
    agreeConditions,
    agreeMandate,
}) {
    const doc = new jsPDF({
        orientation: "portrait",
        unit: "mm",
        format: "a4"
    });

    // Colors
    const orange = [232, 139, 0];
    const gray = [120, 120, 120];

    // --- Dynamic vertical positioning ---
    let y = 15; // Start at top margin

    // Logo
    if (logoBase64) {
        const origWidth = 60;
        const origHeight = 20;
        const scale = 0.95;
        const width = origWidth * scale;
        const height = origHeight * scale;
        doc.addImage(logoBase64, 'PNG', 15, y, width, height);
        y += height + 5;
    }

    // Title
    doc.setFont("helvetica", "bold");
    doc.setFontSize(18);
    doc.setTextColor(...orange);
    doc.text(
        "Aanvraagformulier energiemonitoring",
        110,
        y - 15,
        { maxWidth: 85 }
    );
    y += 10;

    // Section: Bedrijfsgegevens
    doc.setFont("helvetica", "bold");
    doc.setFontSize(12);
    doc.setTextColor(0, 0, 0);
    doc.text("Bedrijfsgegevens", 15, y);
    y += 8;

    doc.setFont("helvetica", "normal");
    doc.setFontSize(10);
    doc.text(`Bedrijfsnaam: ${organizationPayload.name}`, 15, y);
    doc.text(`Contactpersoon: ${organizationPayload.contact}`, 100, y);
    y += 7;
    doc.text(`Vestigingsadres: ${organizationPayload.address}`, 15, y);
    doc.text(`E-mailadres: ${organizationPayload.email}`, 100, y);
    y += 7;
    doc.text(`KvK-nummer: ${organizationPayload.chamberOfCommerceNumber}`, 15, y);
    y += 15;

    // Dienstenselectie
    doc.setFont("helvetica", "bold");
    doc.setFontSize(12);
    doc.text("Dienstenselectie", 15, y);
    y += 8;

    doc.setFont("helvetica", "normal");
    doc.setFontSize(10);
    doc.text(
        "Verklaart zich te laten voorzien van energiemonitoring van Energy Department B.V., gevestigd te Amstelveen, ingeschreven in de KvK onder nummer 54696550, en verleent volmacht om namens bovengenoemde organisatie de aangevinkte diensten uit te voeren:",
        15, y, { maxWidth: 180 }
    );
    y += 15;

    // Section: Gebouwen en meters
    doc.setFont("helvetica", "bold");
    doc.setFontSize(12);
    doc.text("Aansluitadressen (eventueel bijlage aanleveren)", 15, y);
    y += 7;

    doc.setFont("helvetica", "normal");
    doc.setFontSize(10);

    if (!buildingsPayload || buildingsPayload.length === 0) {
        doc.text("Geen gebouwen of meters opgegeven", 22, y);
        y += 6;
    } else {
        console.log("Generating buildings and meters section:", buildingsPayload);
        buildingsPayload.forEach((b, idx) => {
            const building = b.request || {};
            doc.setFont("helvetica", "bold");
            doc.text(
                `${idx + 1}: ${building.name || "Gebouw"} ("Adres: "${building.postalCode} ${building.streetNumber}${building.addition ? " " + building.addition : ""})`,
                18,
                y
            );
            y += 6;

            if (b.meterRequests && b.meterRequests.length > 0) {
                b.meterRequests.forEach((meter, mIdx) => {
                    doc.setFont("helvetica", "bold");
                    doc.text(
                        `Meter ${mIdx + 1}: ${meter.ean18 || ""}`,
                        26,
                        y
                    );
                    y += 5;
                    doc.setFont("helvetica", "normal");
                    doc.text(
                        `EAN13: ${building.ean13 || ""} | Type: ${meter.meterType || ""}`,
                        30,
                        y
                    );
                    y += 5;
                    doc.text(
                        `Netbeheerder: ${meter.gridOperator || ""} | Externe Dataprovider: ${meter.externalDataProvider || ""} `,
                        30,
                        y
                    );
                    y += 6;
                });
            } else {
                doc.text("Geen meters geselecteerd", 26, y);
                y += 6;
            }
            y += 2;
        });
    }
    y += 6;

    // Section: Ondertekening
    doc.setFont("helvetica", "bold");
    doc.setFontSize(12);
    doc.setTextColor(0, 0, 0);
    doc.text("Ondertekening", 15, y);
    y += 8;

    doc.setFont("helvetica", "normal");
    doc.setFontSize(10);
    doc.text("Namens", 15, y);
    doc.text("Namens", 100, y);
    y += 7;
    doc.text("Naam tekenbevoegde:", 15, y);
    doc.text("Naam tekenbevoegde: Raymond Dernier", 100, y);
    y += 7;
    doc.text("Functie:", 15, y);
    doc.text("Functie: Directeur", 100, y);
    y += 7;
    doc.text("Geboortedatum:", 15, y);
    doc.text("Geboortedatum:", 100, y);
    y += 7;
    doc.text("Plaats:", 15, y);
    doc.text("Plaats: Amstelveen", 100, y);
    y += 7;
    if (agreeConditions && agreeMandate) {
        doc.text("Digitale instemming: Akkoord via online formulier", 15, y);
        doc.text("Digitale instemming: Akkoord via online formulier", 100, y);
    } else {
        doc.text("Handtekening:", 15, y);
        doc.text("Handtekening:", 100, y);
    }

    y += 42;

    // Footer
    doc.setFontSize(8);
    doc.setTextColor(...gray);
    doc.text("Energy Department BV – Stroombaan 6-8 1181VX – Amstelveen – Telefoon 020 220 9090 – KvK 54696550", 15, 285);
    doc.text("info@edepartment.nl – www.edepartment.nl", 15, 290);

    doc.save("Mandate_Agreement.pdf");
}